
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Footer from './components/common/Footer';
import Navbar from './components/common/Navbar';
import Home from './components/Home/Home';
// import Detail from './components/DetailPage/Detail';
import DetailPage from './components/DetailPage/DetailPage';
import GaynoFull from './components/Gyano/GaynoFull';
import LipomaDetail from './components/lipoma/LipomaDetail';
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import { useEffect } from 'react';
import Blog from './components/BlogDetail/Blog';
import BlogOne from './components/BlogDetail/BlogOne';
import BlogTwo from './components/BlogDetail/BlogTwo';
import Ophthalmology from './components/ophthalmology/Ophthalmology';
import Doctor from './components/Doctor/Doctor';
import Orthopedic from './components/Orthopedic/Orthopedic';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rhinoplasty" element={<DetailPage />} />
        <Route path="/gynaecomastia" element={<GaynoFull />} />
        <Route path="/lipoma-removal" element={<LipomaDetail />} />
        <Route path="/ophthalmology" element={<Ophthalmology />} />
        {/* <Route path="/orthopedic" element={<Orthopedic />} /> */}
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/doctor-consultant" element={<Doctor />} />
        <Route
          path="/blog/understanding-the-procedure-and-its-effective-treatments-by-an-expert"
          element={<Blog />}
        />
        <Route
          path="/blog/understanding-rhinoplasty-what-you-need-to-know-about-nose-reshaping-surgery"
          element={<BlogOne />}
        />
        <Route
          path="/blog/why-you-need-a-plastic-surgeon-understanding-the-benefits-of-specialized-care"
          element={<BlogTwo />}
        />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
